(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/onetrust/assets/javascripts/onetrust.js') >= 0) return;  svs.modules.push('/components/components/onetrust/assets/javascripts/onetrust.js');

'use strict';

(() => {
  if (!svs.components.onetrust.data.enabled) {
    return;
  }
  const logger = svs.core.log.getLogger('component:onetrust');
  const getOptionsFromCookie = () => {
    try {
      var _document$cookie$matc;
      let cookie = (_document$cookie$matc = document.cookie.match('(^|;)\\s*OptanonConsent\\s*=\\s*([^;]+)')) === null || _document$cookie$matc === void 0 ? void 0 : _document$cookie$matc.pop();
      if (!cookie) {
        return {
          required: false,
          performance: false,
          personalization: false,
          targeting: false
        };
      }
      cookie = decodeURIComponent(cookie);
      cookie = new URLSearchParams(cookie);
      const groups = cookie.get('groups').split(',');
      return {
        required: groups[0].slice(-1) === '1',
        performance: groups[1].slice(-1) === '1',
        personalization: groups[2].slice(-1) === '1',
        targeting: groups[3].slice(-1) === '1'
      };
    } catch (e) {
      logger.warn('Unable to parse Onetrust cookie "OptanonConsent"');
      return {
        required: false,
        performance: false,
        personalization: false,
        targeting: false
      };
    }
  };
  let OnetrustOptions = getOptionsFromCookie();

  window.OptanonWrapper = () => {
    let refreshPage = false;
    const newOptions = getOptionsFromCookie();
    if (OnetrustOptions.performance !== newOptions.performance) {
      const analyticsConsent = new svs.components.analytics.customEvents.AnalyticsConsentChanged(newOptions.performance);
      analyticsConsent.track();
      refreshPage = true;
    }
    if (OnetrustOptions.personalization !== newOptions.personalization) {
      const personalizedConsent = new svs.components.analytics.customEvents.PersonalizedConsentChanged(newOptions.personalization);
      personalizedConsent.track();
      refreshPage = true;
    }
    OnetrustOptions = newOptions;
    if (refreshPage) {
      location.reload(true);
    }
  };
})();

 })(window);